"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BundlePlanBlank = exports.BundlePlanRequestDTOSchema = exports.BundlePlanDTO = exports.BundlePlanDTOSchema = exports.BundlePlanSchema = exports.BundlePlanBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
exports.BundlePlanBaseSchema = zod_1.z.object({
    name: zod_1.z.string().min(1),
    tokensGranted: zod_1.z.number().min(1),
    priceEur: zod_1.z.number().min(0),
    stripePriceId: zod_1.z.string().min(1),
    isActive: zod_1.z.boolean().default(true),
    isDefault: zod_1.z.boolean().default(false),
});
exports.BundlePlanSchema = exports.BundlePlanBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.BundlePlanDTOSchema = exports.BundlePlanSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.BundlePlanDTO = {
    convertFromModel: function (model) {
        return {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            name: model.name,
            tokensGranted: model.tokensGranted,
            priceEur: model.priceEur,
            stripePriceId: model.stripePriceId,
            isActive: model.isActive,
            isDefault: model.isDefault,
        };
    },
};
exports.BundlePlanRequestDTOSchema = exports.BundlePlanDTOSchema.extend(CommonMongoModelFields_1.CommonModelRequestDTOFields);
exports.BundlePlanBlank = {
    name: '',
    tokensGranted: 1,
    priceEur: 0,
    stripePriceId: '',
    isActive: true,
    isDefault: false,
};
//# sourceMappingURL=BundlePlan.js.map